import { FESTIVAL } from '../../data/full/festival';
import { compound } from '../effects';
import type { SimState } from '../state';

export function heldScale(held: number): SimState['enemyScale'] {
  if (held === 0) {
    return undefined;
  }
  const { hp, damage } = FESTIVAL.perStageHeld;
  return { hp: compound(hp, held), damage: compound(damage, held) };
}
